/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplyTemplateRequest {
    getFixupPrototypeFunction() { return ApplyTemplateRequest.fixupPrototype; }

    static newInstance(model: Partial<ApplyTemplateRequest>): ApplyTemplateRequest {
        let obj = Object.assign(new ApplyTemplateRequest(), model);
        ApplyTemplateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplyTemplateRequest>): ApplyTemplateRequest {
        if (!model) return null;
        return ApplyTemplateRequest.newInstance(<ApplyTemplateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplyTemplateRequest) {
        if (!obj) return;

        models.ApplyTemplateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplyTemplateRequest): boolean {
        Object.setPrototypeOf(obj, ApplyTemplateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the cloud_account_id to which the template to be applied
     */
    cloud_accounts: Array<string>;

    /**
     * Select the regions to which the template to be applied, when the AWS cloud account is selected
     */
    regions: Array<string>;

    /**
     * Select the resource_groups to which the template to be applied, when the Azure cloud account is selected
     */
    resource_groups: Array<string>;

    /**
     * Specify the monitoring_template_uri of the template to be applied
     */
    monitoring_template_uri: string;

}
